module.exports = __webpack_public_path__ + "img/rhcp.2a881064.jpg";